/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "identityverifier": {
        "nested": {
          "model": {
            "nested": {
              "Document": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "DocumentType": {
                "values": {
                  "DO_NOT_USE_DOCUMENT_TYPE": 0,
                  "PASSPORT": 1,
                  "DRIVERS_LICENSE": 2,
                  "ID_CARD": 3,
                  "RESIDENCE_PERMIT": 4
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.Document && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.DocumentType) {
  $root.addJSON(jsonData);
}

/**
 * Container for a specific document.
 *
 * SOURCE Document @ squareup/identityverifier/model/document.proto at 11:1
 */
export const Document = $root.lookupType('squareup.identityverifier.model.Document');
fixType(Document, {
  token: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Document);
/**
 * SOURCE DocumentType @ squareup/identityverifier/model/document.proto at 16:1
 */
export const DocumentType = $root.lookupEnum('squareup.identityverifier.model.DocumentType').values;